import { render, staticRenderFns } from "./UploadVideoPreview.vue?vue&type=template&id=29f166aa&scoped=true&"
import script from "./UploadVideoPreview.vue?vue&type=script&lang=js&"
export * from "./UploadVideoPreview.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideoPreview.vue?vue&type=style&index=0&id=29f166aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f166aa",
  null
  
)

export default component.exports